export const REFERRAL_NAV_Z_INDEX = 10
export const DECOR_1_Z_INDEX = 1
